import { FormControl } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { UserProfile } from 'src/app/core/models/user';
//import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
//import { MatLegacyChipInputEvent as MatChipInputEvent } from '@angular/material/legacy-chips';
import { FilterViewModel } from 'src/app/core/models/regulation';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { LibraryType } from 'src/app/core/enums/regulator/regulator-status';
import { SessionService } from './../../../core/services/auth/session.service';
import { UserInfoData } from 'src/app/core/models/user-management/user-info-data';
import { FilterItems } from './../../../core/models/user-management/filter-items';
import { ChangeViewerLibrary } from 'src/app/core/models/regulation/change-viewer-library';
import { RegulationService } from './../../../core/services/regulation/regulation.service';
import { UserInfoFilterModel } from 'src/app/core/models/user-management/user-filter-model';
import { FilterItemListModel } from 'src/app/core/models/filter-model/filter-item-list-model';
//import { MatLegacyAutocomplete as MatAutocomplete, MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { UserManagementService } from './../../../core/services/user-management/user-management.service';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialogRef } from '@angular/material/dialog';
import { MatChipInputEvent } from '@angular/material/chips';
import { GlobalService } from 'src/app/core/services/global/global.service';

@Component({
  selector: 'app-share-library-dialog',
  templateUrl: './share-library-dialog.component.html',
  styleUrls: ['./share-library-dialog.component.scss'],
})
export class ShareLibraryDialogComponent implements OnInit {
  user: UserProfile;
  searchStr: string;
  regulationLibrary: Array<ChangeViewerLibrary>;
  userData: UserInfoData;
  isRLAllow = true;
  isUAllow = true;
  isShareLoading = false;
  selectedLibraryType: Array<LibraryType>;
  isGlobal = false;
  isShareGlobally = false;

  regLibraryDD: string[] = [];
  userDD: string[] = [];

  selRegLibraryId: number[] = [];
  selUsersId: string[] = [];

  searchedLibrary: FilterViewModel[] = [];
  searchedUser: FilterViewModel[] = [];

  allSearchedLibrary: FilterViewModel[] = [];
  allSearchedUser: FilterViewModel[] = [];

  searchRLCntrl: FormControl = new FormControl();
  searchUserCntrl: FormControl = new FormControl();

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];

  @ViewChild('rlInput')
  rlInput!: ElementRef<HTMLInputElement>;
  @ViewChild('rlAutocomplete')
  rlAutocomplete!: MatAutocomplete;

  @ViewChild('usrInput')
  usrInput!: ElementRef<HTMLInputElement>;
  @ViewChild('usrAutocomplete')
  usrAutocomplete!: MatAutocomplete;

  constructor(
    private dialogRef: MatDialogRef<ShareLibraryDialogComponent>,
    private sessionService: SessionService,
    private regulationService: RegulationService,
    private userService: UserManagementService,
    private _globalService: GlobalService
  ) {
    this.user = new UserProfile();
    this.searchStr = '';
    this.regulationLibrary = [];
    this.userData = new UserInfoData();
    this.selectedLibraryType = [];
  }

  ngOnInit(): void {
    this.getUserProfile();
  }

  async getUserProfile() {
    this.user = await this._globalService.getLoginUserData();
    this.fetchRegulationLibrary();
    this.fetchAllUsers();
  }

  fetchRegulationLibrary(): void {
    this.regulationService.getRegulationLibrary('LibraryName', false).subscribe((data: Array<ChangeViewerLibrary>) => {
      this.regulationLibrary = data;
      if (data && data.length > 0) {
        data.forEach((element) => {
          this.searchedLibrary.push({
            name: element.libraryName,
            value: element.libraryName,
            geography:""
          });
          this.allSearchedLibrary.push({
            name: element.libraryName,
            value: element.libraryName,
            geography:""
          });
        });
      }
    });
  }

  fetchAllUsers(): void {
    this.isShareLoading = true;
    const filter = new FilterItems();
    const filterItems = new UserInfoFilterModel();
    filterItems.division = [];
    filterItems.filters = filter;
    this.userService.getAllUsersListForAllRole(filterItems).subscribe((data: UserInfoData) => {
      this.userData = data;
      for (let i = 0; i < data.userList.length; i++) {
        if (data.userList[i].emailId === 'amit.madahar@finreg-e.com') {
          data.userList.splice(i, 1);
        }
        if (data.userList[i].externalUserId === this.user.externalUserId) {
          data.userList.splice(i, 1);
        }
      }
      if (data && data.userList.length > 0) {
        data.userList.forEach((element) => {
          this.searchedUser.push({
            name: element.fullName,
            value: element.fullName,
            geography:""
          });
          this.allSearchedUser.push({
            name: element.fullName,
            value: element.fullName,
            geography:""
          });
        });
      }
      this.isShareLoading = false;
    });
  }

  shareRegulationLibrary(): void {
    const dataItems = new FilterItemListModel();
    dataItems.itemId = this.selRegLibraryId;
    dataItems.externalUserId = this.selUsersId;
    if (this.selRegLibraryId.length === 0) {
      this.isRLAllow = false;
      setTimeout(() => {
        this.isRLAllow = true;
      }, 3000);
    } else if (this.selUsersId.length === 0) {
      this.isUAllow = false;
      setTimeout(() => {
        this.isUAllow = true;
      }, 3000);
    } else {
      dataItems.isShareGlobally = this.isGlobal;
      this.dialogRef.close(dataItems);
    }
  }

  getFilteredData(filter: string, event: any): void {
    this.searchStr += event.key;
    switch (filter) {
      case 'RegulationLibrary':
        const searchedA = Array<FilterViewModel>();
        if (this.searchedLibrary.length > 0) {
          this.searchedLibrary.forEach((element) => {
            if (
              element.value.toLowerCase().includes(this.searchStr.toLowerCase())
            ) {
              searchedA.push(element);
            }
          });
          this.searchedLibrary = searchedA;
        } else {
          this.searchedLibrary = this.allSearchedLibrary;
        }
        break;
      case 'User':
        const searchedAD = Array<FilterViewModel>();
        if (this.searchedUser.length > 0) {
          this.searchedUser.forEach((element) => {
            if (
              element.value.toLowerCase().includes(this.searchStr.toLowerCase())
            ) {
              searchedAD.push(element);
            }
          });
          this.searchedUser = searchedAD;
        } else {
          this.searchedUser = this.allSearchedUser;
        }
        break;
    }
    this.searchStr = '';
  }

  // Regulation Library multiselect
  addRL(event: MatChipInputEvent): void {
    if (!this.rlAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.regLibraryDD as string[]).push(value);
        const regL = this.regulationLibrary.find((a) => a.libraryName === value);
        this.selRegLibraryId.push(regL?.id?regL.id:0);
        this.selectedLibraryType.push(regL?.libraryType?regL.libraryType:LibraryType.Static);
      }

      event.chipInput!.clear();
      this.searchRLCntrl.setValue(null);
      this.isShareGlobally = this.checkStaticLibrary();
    }
  }

  selectedRLEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.regLibraryDD) {
      this.regLibraryDD.push(event.option.viewValue);
    } else {
      this.regLibraryDD = [];
      this.regLibraryDD.push(event.option.viewValue);
    }
    const regL = this.regulationLibrary.find((a) => a.libraryName.trim() === event.option.viewValue.trim());
    this.selRegLibraryId.push(regL?.id?regL.id:0);
    this.selectedLibraryType.push(regL?.libraryType?regL.libraryType:LibraryType.Static);

    this.rlInput.nativeElement.value = '';
    this.searchRLCntrl.setValue(null);
    this.searchRLCntrl.disable();
    this.searchRLCntrl.enable();
    this.isShareGlobally = this.checkStaticLibrary();
  }

  removeRL(status: string): void {
    const index = (this.regLibraryDD as string[]).indexOf(status);
    if (index >= 0) {
      (this.regLibraryDD as string[]).splice(index, 1);
    }
    const regLId = this.regulationLibrary.find((a) => a.libraryName.trim() === status.trim())?.id;
    const index2 = (this.selRegLibraryId as number[]).indexOf(regLId?regLId:-1);
    if (index2 >= 0) {
      (this.selRegLibraryId as number[]).splice(index2, 1);
    }
    const regL = this.regulationLibrary.find((a) => a.libraryName.trim() === status.trim());
    const index3 = (this.selectedLibraryType as LibraryType[]).indexOf(regL?.libraryType?regL?.libraryType:-1);
    if (index3 >= 0) {
      (this.selectedLibraryType as LibraryType[]).splice(index3, 1);
    }
    this.isShareGlobally = this.checkStaticLibrary();
  }

  // User multiselect
  addUser(event: MatChipInputEvent): void {
    if (!this.usrAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        (this.userDD as string[]).push(value);
        const usrId = this.userData.userList.find(
          (a) => a.fullName === value
        )?.externalUserId;
        if(usrId === undefined) return;
        this.selUsersId.push(usrId);
      }

      event.chipInput!.clear();
      this.searchUserCntrl.setValue(null);
    }
  }

  selectedUserEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.userDD) {
      this.userDD.push(event.option.viewValue);
    } else {
      this.userDD = [];
      this.userDD.push(event.option.viewValue);
    }
    const usrId = this.userData.userList.find(
      (a) => a.fullName === event.option.viewValue
    )?.externalUserId;
    if(usrId === undefined) return;
    this.selUsersId.push(usrId);
    this.usrInput.nativeElement.value = '';
    this.searchUserCntrl.setValue(null);
    this.searchUserCntrl.disable();
    this.searchUserCntrl.enable();
  }

  removeUser(status: string): void {
    const index = (this.userDD as string[]).indexOf(status);
    if (index >= 0) {
      (this.userDD as string[]).splice(index, 1);
    }

    const usrId = this.userData.userList.find(
      (a) => a.fullName === status
    )?.externalUserId;
    if(usrId === undefined) return;
    const index2 = (this.selUsersId as string[]).indexOf(usrId);
    if (index2 >= 0) {
      (this.selUsersId as string[]).splice(index2, 1);
    }
  }

  getIconClass(title: string): string {
    const regLib = this.regulationLibrary.find((a) => a.libraryName === title);
    return regLib?.libraryType === LibraryType.Static
      ? 'fa fa-thumb-tack'
      : 'fa fa-bolt';
  }

  checkStaticLibrary(): boolean {
    if (this.selectedLibraryType.length === 0) {
      return false;
    } else {
      const indexOf = this.selectedLibraryType.indexOf(LibraryType.Dynamic);
      return indexOf >= 0 ? false : true;
    }
  }
}
